var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-map"},[(_vm.getHideMapBlock)?_c('div',{staticClass:"hide"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.mapShow(false)}}},[_vm._v("знайти аптеку на мапі")])]):_vm._e(),_c('div',{ref:"searchMap",staticClass:"google-map",attrs:{"id":"global-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }